import { FC } from 'react'
import { FilterCriteriaValueFieldProps } from './FilterCriteriaValueFieldProps'
import { Autocomplete, TextField } from '@mui/material'
import { useSelectSingleMulti } from './useSelectSingleMulti'

export const FilterCriteriaValueSelect: FC<FilterCriteriaValueFieldProps> = ({
  assumption,
  operator,
  fieldProps: { value, onChange, error, ...fieldProps },
}) => {
  const { calculatedValue, handleChange, multiple } = useSelectSingleMulti({
    value,
    onChange,
    operator,
  })

  return (
    <Autocomplete
      multiple={multiple}
      renderInput={(params) => <TextField variant="outlined" error={error} {...params} />}
      options={assumption.selectOptions!}
      onChange={handleChange}
      value={calculatedValue}
      slotProps={{ chip: { size: 'small' } }}
      {...fieldProps}
    />
  )
}
